import React, { useEffect, useState } from "react";
import { FolderOpenOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Row,
  Typography,
  Col,
  Button,
  Tooltip,
  Table,
  Collapse,
  Badge,
} from "antd";
import { apiConfig, labelConfig, staticConfig } from "../../group.config";
import { BOM } from "../../../../services/definedMethod";

const { Title, Text } = Typography;
const { Panel } = Collapse;

function AccountsOverview(props) {
  const {
    loansList,
    savingsList,
    groupDetails,
    GSIMSavingsList,
    GLIMLoansList,
    state,
  } = props;
  const navigate = useNavigate();
  useEffect(() => {}, []);

  const GLIMLoanColumns = [
    {
      title: "GLIM ID",
      dataIndex: "id",
    },
    {
      title: " Account Number",
      dataIndex: "accountNo",
    },
    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Original Loan",
      dataIndex: "originalLoan",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <Tooltip title={`View Account`}>
            <Button
              type="primary"
              icon={<FolderOpenOutlined />}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
              disabled={!BOM.HasPermission("READ_LOAN")}
              onClick={() => (
                (record.key = record.id),
                navigate("/detail-parent-glim", {
                  state: { parentId: record.id, groupId: record.groupId },
                })
              )}
            />
          </Tooltip>
        </>
      ),
    },
  ];

  const GSIMAccountColumns = [
    {
      title: "GSIM ID",
      dataIndex: "gsimId",
    },
    {
      title: " Account Number",
      dataIndex: "accountNo",
    },
    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Balance",
      dataIndex: "balance",
    },

    {
      title: "Status",
      dataIndex: "accountStatus",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <Tooltip title={`View Account`}>
            <Button
              type="primary"
              icon={<FolderOpenOutlined />}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
              disabled={!BOM.HasPermission("READ_SAVINGSACCOUNT")}
              onClick={() => (
                delete record.accounStatus,
                navigate("/detail-group-gsim", {
                  state: {
                    ...state,
                    accountNo: record.accountNo,
                    parentGSIMApplicationId: record.childGSIMAccountId,
                    gsimId: record.gsimId,
                  },
                })
              )}
            />
          </Tooltip>
        </>
      ),
    },
  ];

  const loanAccountColumns = [
    {
      title: " Account Number",
      dataIndex: "accountNo",
    },
    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Original Loan",
      dataIndex: "originalLoan",
    },
    {
      title: "Loan Balance",
      dataIndex: "loanBalance",
    },
    {
      title: "Amount Paid",
      dataIndex: "amountPaid",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Status",
      dataIndex: "accountStatus",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <Tooltip title={`View Account`}>
            <Button
              type="primary"
              icon={<FolderOpenOutlined />}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
              disabled={!BOM.HasPermission("READ_LOAN")}
              onClick={() => (
                delete record.accountStatus,
                navigate("/detail-group-loan", {
                  state: { ...record, groupId: groupDetails.id },
                })
              )}
            />
          </Tooltip>
        </>
      ),
    },
  ];

  const savingsAccountColumns = [
    {
      title: " Account Number",
      dataIndex: "accountNo",
    },
    {
      title: "Product Name",
      dataIndex: "productName",
    },
    {
      title: "Balance",
      dataIndex: "balance",
    },
    //I USED accountStatus as dataIndex because the record already has status. It'd be overwritten
    {
      title: "Status",
      dataIndex: "accounStatus",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <Tooltip title={`View Account`}>
            <Button
              type="primary"
              icon={<FolderOpenOutlined />}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
              disabled={!BOM.HasPermission("READ_SAVINGSACCOUNT")}
              onClick={() => (
                delete record.accounStatus,
                navigate("/detail-group-savings", {
                  state: { ...record, mainGrpId: groupDetails.id },
                })
              )}
            />
          </Tooltip>
        </>
      ),
    },
  ];

  const handleAccountType = (keyParam) => {
    switch (keyParam.toLowerCase()) {
      case "glimloan":
        return GLIMLoansList;
      case "gsimaccount":
        return GSIMSavingsList;
      case "loan":
        return loansList;
      case "savings":
        return savingsList;
      //   .filter(
      //     (item) => item?.depositType?.value?.toLowerCase() === keyParam
      //   );
      default:
        return [];
    }
  };

  const handlePanelHeader = (typeParam, labelParam1, labelParam2) => {
    return (
      <Badge count={handleAccountType(typeParam).length}>
        <Title level={5} style={{ margin: 3 }}>
          {handleAccountType(typeParam).length <= 1 ? labelParam1 : labelParam2}
        </Title>
      </Badge>
    );
  };

  return (
    <Row>
      <Col span={24} style={{ padding: "0px 8px" }}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={handlePanelHeader(
              "GLIMLoan",
              labelConfig.GLIMLoansAccount,
              labelConfig.GLIMLoansAccounts
            )}
            key="1"
          >
            <Table
              columns={GLIMLoanColumns}
              dataSource={handleAccountType("GLIMLoan")}
            />
          </Panel>
        </Collapse>
      </Col>
      <Col span={24} style={{ padding: "0px 8px" }}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={handlePanelHeader(
              "GSIMAccount",
              labelConfig.GSIMAccount,
              labelConfig.GSIMAccounts
            )}
            key="1"
          >
            <Table
              columns={GSIMAccountColumns}
              dataSource={handleAccountType("GSIMAccount")}
            />
          </Panel>
        </Collapse>
      </Col>

      <Col span={24} style={{ padding: "0px 8px" }}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={handlePanelHeader(
              "loan",
              labelConfig.loansAccount,
              labelConfig.loansAccounts
            )}
            key="1"
          >
            <Table
              columns={loanAccountColumns}
              dataSource={handleAccountType("loan")}
            />
          </Panel>
        </Collapse>
      </Col>

      <Col span={24} style={{ padding: "0px 8px" }}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={handlePanelHeader(
              "savings",
              labelConfig.savingsAccount,
              labelConfig.savingsAccounts
            )}
            key="1"
          >
            <Table
              columns={savingsAccountColumns}
              dataSource={handleAccountType("savings")}
            />
          </Panel>
        </Collapse>
      </Col>
    </Row>
  );
}

export default AccountsOverview;
